/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { organizationUserSessionIssuersCreate } from "../funcs/organizationUserSessionIssuersCreate.js";
import { organizationUserSessionIssuersCreateCimdClient } from "../funcs/organizationUserSessionIssuersCreateCimdClient.js";
import { organizationUserSessionIssuersDelete } from "../funcs/organizationUserSessionIssuersDelete.js";
import { organizationUserSessionIssuersDeleteCimdClient } from "../funcs/organizationUserSessionIssuersDeleteCimdClient.js";
import { organizationUserSessionIssuersGet } from "../funcs/organizationUserSessionIssuersGet.js";
import { organizationUserSessionIssuersGetAuthenticationHostImpact } from "../funcs/organizationUserSessionIssuersGetAuthenticationHostImpact.js";
import { organizationUserSessionIssuersGetCimdClient } from "../funcs/organizationUserSessionIssuersGetCimdClient.js";
import { organizationUserSessionIssuersGetDeletePreflight } from "../funcs/organizationUserSessionIssuersGetDeletePreflight.js";
import { organizationUserSessionIssuersGetMigratePreflight } from "../funcs/organizationUserSessionIssuersGetMigratePreflight.js";
import { organizationUserSessionIssuersList } from "../funcs/organizationUserSessionIssuersList.js";
import { organizationUserSessionIssuersListCimdClients } from "../funcs/organizationUserSessionIssuersListCimdClients.js";
import { organizationUserSessionIssuersListMcpServers } from "../funcs/organizationUserSessionIssuersListMcpServers.js";
import { organizationUserSessionIssuersMigrate } from "../funcs/organizationUserSessionIssuersMigrate.js";
import { organizationUserSessionIssuersMove } from "../funcs/organizationUserSessionIssuersMove.js";
import { organizationUserSessionIssuersSetAuthenticationHost } from "../funcs/organizationUserSessionIssuersSetAuthenticationHost.js";
import { organizationUserSessionIssuersUpdate } from "../funcs/organizationUserSessionIssuersUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { CreateUserSessionIssuerCimdClientResult } from "../models/components/createusersessionissuercimdclientresult.js";
import { MigrateOrganizationUserSessionIssuerResult } from "../models/components/migrateorganizationusersessionissuerresult.js";
import { OrganizationUserSessionIssuerDeletePreflight } from "../models/components/organizationusersessionissuerdeletepreflight.js";
import { OrganizationUserSessionIssuerMigratePreflight } from "../models/components/organizationusersessionissuermigratepreflight.js";
import { UserSessionIssuer } from "../models/components/usersessionissuer.js";
import { UserSessionIssuerAuthenticationHostImpact } from "../models/components/usersessionissuerauthenticationhostimpact.js";
import { UserSessionIssuerCimdClient } from "../models/components/usersessionissuercimdclient.js";
import {
  CreateOrganizationUserSessionIssuerRequest,
  CreateOrganizationUserSessionIssuerSecurity,
} from "../models/operations/createorganizationusersessionissuer.js";
import {
  CreateOrganizationUserSessionIssuerCimdClientRequest,
  CreateOrganizationUserSessionIssuerCimdClientSecurity,
} from "../models/operations/createorganizationusersessionissuercimdclient.js";
import {
  DeleteOrganizationUserSessionIssuerRequest,
  DeleteOrganizationUserSessionIssuerSecurity,
} from "../models/operations/deleteorganizationusersessionissuer.js";
import {
  DeleteOrganizationUserSessionIssuerCimdClientRequest,
  DeleteOrganizationUserSessionIssuerCimdClientSecurity,
} from "../models/operations/deleteorganizationusersessionissuercimdclient.js";
import {
  GetOrganizationUserSessionIssuerRequest,
  GetOrganizationUserSessionIssuerSecurity,
} from "../models/operations/getorganizationusersessionissuer.js";
import {
  GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest,
  GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity,
} from "../models/operations/getorganizationusersessionissuerauthenticationhostimpact.js";
import {
  GetOrganizationUserSessionIssuerCimdClientRequest,
  GetOrganizationUserSessionIssuerCimdClientSecurity,
} from "../models/operations/getorganizationusersessionissuercimdclient.js";
import {
  GetOrganizationUserSessionIssuerDeletePreflightRequest,
  GetOrganizationUserSessionIssuerDeletePreflightSecurity,
} from "../models/operations/getorganizationusersessionissuerdeletepreflight.js";
import {
  GetOrganizationUserSessionIssuerMigratePreflightRequest,
  GetOrganizationUserSessionIssuerMigratePreflightSecurity,
} from "../models/operations/getorganizationusersessionissuermigratepreflight.js";
import {
  ListOrganizationUserSessionIssuerCimdClientsRequest,
  ListOrganizationUserSessionIssuerCimdClientsResponse,
  ListOrganizationUserSessionIssuerCimdClientsSecurity,
} from "../models/operations/listorganizationusersessionissuercimdclients.js";
import {
  ListOrganizationUserSessionIssuerMcpServersRequest,
  ListOrganizationUserSessionIssuerMcpServersResponse,
  ListOrganizationUserSessionIssuerMcpServersSecurity,
} from "../models/operations/listorganizationusersessionissuermcpservers.js";
import {
  ListOrganizationUserSessionIssuersRequest,
  ListOrganizationUserSessionIssuersResponse,
  ListOrganizationUserSessionIssuersSecurity,
} from "../models/operations/listorganizationusersessionissuers.js";
import {
  MigrateOrganizationUserSessionIssuerRequest,
  MigrateOrganizationUserSessionIssuerSecurity,
} from "../models/operations/migrateorganizationusersessionissuer.js";
import {
  MoveOrganizationUserSessionIssuerRequest,
  MoveOrganizationUserSessionIssuerSecurity,
} from "../models/operations/moveorganizationusersessionissuer.js";
import {
  SetOrganizationUserSessionIssuerAuthenticationHostRequest,
  SetOrganizationUserSessionIssuerAuthenticationHostSecurity,
} from "../models/operations/setorganizationusersessionissuerauthenticationhost.js";
import {
  UpdateOrganizationUserSessionIssuerRequest,
  UpdateOrganizationUserSessionIssuerSecurity,
} from "../models/operations/updateorganizationusersessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class OrganizationUserSessionIssuers extends ClientSDK {
  /**
   * createIssuer organizationUserSessionIssuers
   *
   * @remarks
   * Create an organization-owned user_session_issuer. Requires org:admin.
   */
  async create(
    request: CreateOrganizationUserSessionIssuerRequest,
    security?: CreateOrganizationUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuer> {
    return unwrapAsync(organizationUserSessionIssuersCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createCimdClient organizationUserSessionIssuers
   *
   * @remarks
   * Allow an additional CIMD document URL on an organization-owned user_session_issuer. Requires org:admin.
   */
  async createCimdClient(
    request: CreateOrganizationUserSessionIssuerCimdClientRequest,
    security?:
      | CreateOrganizationUserSessionIssuerCimdClientSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<CreateUserSessionIssuerCimdClientResult> {
    return unwrapAsync(organizationUserSessionIssuersCreateCimdClient(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteIssuer organizationUserSessionIssuers
   *
   * @remarks
   * Soft-delete an organization-owned user_session_issuer. Refuses while a live MCP server or toolset references it. Requires org:admin.
   */
  async delete(
    request: DeleteOrganizationUserSessionIssuerRequest,
    security?: DeleteOrganizationUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(organizationUserSessionIssuersDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteCimdClient organizationUserSessionIssuers
   *
   * @remarks
   * Remove a custom CIMD document URL from an organization-owned user_session_issuer. Requires org:admin.
   */
  async deleteCimdClient(
    request: DeleteOrganizationUserSessionIssuerCimdClientRequest,
    security?:
      | DeleteOrganizationUserSessionIssuerCimdClientSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(organizationUserSessionIssuersDeleteCimdClient(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getIssuer organizationUserSessionIssuers
   *
   * @remarks
   * Get any user_session_issuer in the caller's organization, organization-owned or project-specific, by id. Requires org:read.
   */
  async get(
    request: GetOrganizationUserSessionIssuerRequest,
    security?: GetOrganizationUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuer> {
    return unwrapAsync(organizationUserSessionIssuersGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getAuthenticationHostImpact organizationUserSessionIssuers
   *
   * @remarks
   * Preview moving a user_session_issuer in the caller's organization onto or off the deployment's authentication host: where clients sign in before and after, and how many MCP servers that affects. Requires org:read.
   */
  async getAuthenticationHostImpact(
    request: GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest,
    security?:
      | GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuerAuthenticationHostImpact> {
    return unwrapAsync(
      organizationUserSessionIssuersGetAuthenticationHostImpact(
        this,
        request,
        security,
        options,
      ),
    );
  }

  /**
   * getCimdClient organizationUserSessionIssuers
   *
   * @remarks
   * Get a custom CIMD document URL on an organization-owned user_session_issuer. Requires org:read.
   */
  async getCimdClient(
    request: GetOrganizationUserSessionIssuerCimdClientRequest,
    security?: GetOrganizationUserSessionIssuerCimdClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuerCimdClient> {
    return unwrapAsync(organizationUserSessionIssuersGetCimdClient(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getIssuerDeletePreflight organizationUserSessionIssuers
   *
   * @remarks
   * Report the clients, live sessions, MCP servers, and toolsets affected by deleting an organization-owned user_session_issuer. Requires org:read.
   */
  async getDeletePreflight(
    request: GetOrganizationUserSessionIssuerDeletePreflightRequest,
    security?:
      | GetOrganizationUserSessionIssuerDeletePreflightSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<OrganizationUserSessionIssuerDeletePreflight> {
    return unwrapAsync(organizationUserSessionIssuersGetDeletePreflight(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getIssuerMigratePreflight organizationUserSessionIssuers
   *
   * @remarks
   * Report the impact, blockers, and configuration warnings for consolidating one user_session_issuer onto another. Requires org:read.
   */
  async getMigratePreflight(
    request: GetOrganizationUserSessionIssuerMigratePreflightRequest,
    security?:
      | GetOrganizationUserSessionIssuerMigratePreflightSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<OrganizationUserSessionIssuerMigratePreflight> {
    return unwrapAsync(organizationUserSessionIssuersGetMigratePreflight(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listIssuers organizationUserSessionIssuers
   *
   * @remarks
   * List the user_session_issuers in the caller's organization: organization-owned and project-specific, each project-specific issuer with its owning project name. Requires org:read.
   */
  async list(
    request?: ListOrganizationUserSessionIssuersRequest | undefined,
    security?: ListOrganizationUserSessionIssuersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<ListOrganizationUserSessionIssuersResponse, { cursor: string }>
  > {
    return unwrapResultIterator(organizationUserSessionIssuersList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listCimdClients organizationUserSessionIssuers
   *
   * @remarks
   * List custom CIMD document URLs on an organization-owned user_session_issuer. Requires org:read.
   */
  async listCimdClients(
    request: ListOrganizationUserSessionIssuerCimdClientsRequest,
    security?: ListOrganizationUserSessionIssuerCimdClientsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<
      ListOrganizationUserSessionIssuerCimdClientsResponse,
      { cursor: string }
    >
  > {
    return unwrapResultIterator(organizationUserSessionIssuersListCimdClients(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listMcpServers organizationUserSessionIssuers
   *
   * @remarks
   * List the live MCP servers, toolsets, and meta MCP servers attached to a user_session_issuer in the caller's organization, organization-owned or project-specific. A toolset served through an MCP server is listed once, as that server. Requires org:read.
   */
  async listMcpServers(
    request: ListOrganizationUserSessionIssuerMcpServersRequest,
    security?: ListOrganizationUserSessionIssuerMcpServersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<
      ListOrganizationUserSessionIssuerMcpServersResponse,
      { cursor: string }
    >
  > {
    return unwrapResultIterator(organizationUserSessionIssuersListMcpServers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * migrateIssuer organizationUserSessionIssuers
   *
   * @remarks
   * Consolidate a source user_session_issuer onto a target issuer, preserving clients, sessions, attachments, and remote-session credentials before soft-deleting the source. The target must be in the same project or a broader organization scope. Access tokens issued through the authorization_code and refresh_token grants are audience-bound to the issuer, so once a repointed MCP server verifies bearers against the target, outstanding access tokens minted under the source are rejected until the client refreshes. Migrated sessions and refresh tokens keep working, so the refresh succeeds without re-authorization. Tokens from the jwt-bearer (ID-JAG) grant are bound to the resource URL and are unaffected. Requires org:admin.
   */
  async migrate(
    request: MigrateOrganizationUserSessionIssuerRequest,
    security?: MigrateOrganizationUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<MigrateOrganizationUserSessionIssuerResult> {
    return unwrapAsync(organizationUserSessionIssuersMigrate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * moveIssuer organizationUserSessionIssuers
   *
   * @remarks
   * Re-scope a user_session_issuer in the caller's organization. Provide a project_id to make it project-specific, or omit it to make it organization-owned. Existing clients and sessions move with the issuer. Requires org:admin.
   */
  async move(
    request: MoveOrganizationUserSessionIssuerRequest,
    security?: MoveOrganizationUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuer> {
    return unwrapAsync(organizationUserSessionIssuersMove(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setAuthenticationHost organizationUserSessionIssuers
   *
   * @remarks
   * Move a user_session_issuer in the caller's organization onto or off the deployment's authentication host. A shared authorization server with a pinned issuer URL is re-pinned to the matching host, so its issuer URL and token endpoint change; other issuers announce their authorization servers on the new host. Clients and anything configured with the previous URLs must be updated. Refused when the deployment has no authentication host, and for issuers managed by Speakeasy. Requires org:admin.
   */
  async setAuthenticationHost(
    request: SetOrganizationUserSessionIssuerAuthenticationHostRequest,
    security?:
      | SetOrganizationUserSessionIssuerAuthenticationHostSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuer> {
    return unwrapAsync(organizationUserSessionIssuersSetAuthenticationHost(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateIssuer organizationUserSessionIssuers
   *
   * @remarks
   * Update an organization-owned user_session_issuer. Requires org:admin.
   */
  async update(
    request: UpdateOrganizationUserSessionIssuerRequest,
    security?: UpdateOrganizationUserSessionIssuerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UserSessionIssuer> {
    return unwrapAsync(organizationUserSessionIssuersUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
